module.exports = __webpack_public_path__ + "img/slide-15.2796f500.jpeg";